import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import _ from 'lodash';

import { loadState, reset } from './localStorage';
import {
  APP_API_KEY,
  INITIAL_APP_LANGUAGE,
  INITIAL_APP_THEME,
  INSTANCE_URL,
  IS_API4,
  SITE_URL,
  STOP_API_CALLS
} from '../constants/constant';
import {
  ALLOWED_APP_THEMES,
  ALLOWED_REPORTED_CONTENT_STRUCTURE
} from '../constants/section-constants/type-constants';

import {
  STOP_API_CALL_ACTION,
  INTERNET_CONNECTION_LOST,
  DEVICE_SIZE,
  SHOW_SIDEBAR,
  LOGIN_MODAL,
  ACTION_LOGIN,
  SESSION_TOKEN,
  USER_INFO,
  USER_DETAILS,
  USER_DETAILS_ADDON,
  USER_ACCESS,
  ACTION_LOGOUT,
  RESET,
  EVENT_DETAILS,
  EVENT_DETAILS_SESSION,
  EVENT_SETTINGS,
  EVENT_LANGUAGES,
  EVENT_LOCATION_MAPS,
  EVENT_FORMS_DETAILS,
  EVENT_TAB_LIST,
  EVENT_ALL_TICKETS,
  UPDATE_ACTIVE_TAB,
  USER_DETAILS_QR,
  APPUSER_CATEGORIES_LIST,
  INTEREST_LIST,
  EVENT_WEBVIEW_DETAILS,
  EVENT_ADVT_DETAILS,
  REDIRECTING_CALLED_FROM,
  APPLY_COMMON_LOADER,
  ACTIVATE_NAVBAR_LINE_LOADER,
  INVOKE_NETWORK_MODAL,
  TIMEZONE_DETAILS,
  TICKETS_FOR_EVENT,
  MEETING_POPUP_DETAILS,
  FETCH_UNREAD_CHAT,
  UNAUTHORIZED_API_CALLED,
  SITE_CONTROL,
  PROFILE_TOGGLE,
  LAST_MODIFIED_REDUXFORM_FIELD,
  USER_ACCESS_BY_ROLE,
  COMMON_ACCESS_DENIED_RENDER,
  TOKEN_EXPIRY_MODAL_STATUS,
  APPUSER_REPORTED_CONTENT,
  COMMON_FILTER_SELECTED_LIST,
  ON_FIRST_VISIT,
  INITIALIZE_APP,
  CHANGE_APP_LANGUAGE,
  CHANGE_APP_THEME,
  APP_FEATURE_LIST,
  APP_REG_LOGIN_OPEN,
  RESTRICT_USER_IN_EDIT,
  SPEAKER_CATEGORY
} from '../actions';
import {
  SchedulesDataReducers,
  SelectedScheduleDateReducer,
  scheduleTracksDataReducer,
  SelectedScheduleTrackReducer,
  trackSessionsDataReducer,
  sessionDetailsReducer,
  showSidebarReducer,
  showBackScreenReducer,
  openQAModalReducer,
  sessionQADataReducer,
  sessionPolls,
  sessionPollsListModal,
  sessionPollsActionModal,
  sessionPollsResult,
  myBookedSchedule,
  myRatedSessionReducer,
  holdThisSessionDetailsReducer,
  liveQAReplyReducer,
  sessionVideoModalDetails,
  sessionRatingFormDataReducer,
  notSubmittedPollCountReducer,
  sessionsFilteredByTagsReducer,
  sessionColorsReducer,
  allEventTrackReducer,
  sessionFilterData,
  overlappingSessionsForAllTracks
} from '../components/sessions/reducers';
import {
  allSpeakers,
  allSponsors,
  allExhibitors,
  allSessions,
  seenEventAds
} from '../components/event-overview/reducers';
import {
  speakerAttachments,
  speakerAttachmentsChanged,
  workingDynamicForm,
  productCategories,
  productSubCategories,
  masterIndustriesReducer
} from '../components/myprofile/reducers';
import {
  appuserAccess,
  ownOrders,
  appuserAccessedTickets
} from '../components/mytickets/reducers';
import {
  myBookedExhibitor,
  allExhibitors_exb,
  exhibitor,
  exhibitorDetails,
  showOnlyExhibitorDetailsReducer,
  exbCountryReducer,
  exbSectorsReducer,
  exbCategoriesReducer,
  categoryList,
  exhibitorsFilteredReducer,
  exhibitorsTAGFilteredReducer
} from '../components/exhibitors/reducers';
import {
  isVSPopup,
  vsPopupContent,
  vsPopupHeight,
  vsPopupDetails
} from '../components/Common/vertical-sliding-popup/reducers';
import { hsPopupReducer } from '../components/Common/horizontal-sliding-popup/reducers';
import {
  myBookedSponsor,
  allSponsors_spn,
  sponsor,
  sponsorDetails,
  showOnlySponsorDetailsReducer
} from '../components/sponsors/reducers';
import {
  userData,
  openChatReducer,
  chatThreadData,
  chatData,
  viewUserReducer,
  attendeeListModalReducer,
  timeoutListReducer,
  showBackScreenChat,
  suggestedUserDataReducer,
  openSuggestedFilterListReducer
} from '../components/userschat/reducers';
import { newsData, newsDetails, bookedNews } from '../components/news/reducers';
import {
  attendeeList,
  attendeeProfileDetailsReducer,
  showBackScreen,
  myBookmarkedUsers,
  openFilterListReducer,
  matchAttendeeCategoryReducer,
  mainAttendeeList
} from '../components/attendee/reducers';
import {
  bookedSpeakers,
  speakersReducer,
  speakerDetailsReducer,
  showBackScreenSpeaker
} from '../components/speakers/reducers';
import {
  bookmarksByTypeReducer,
  bookmarksDataReducer
} from '../components/bookmarks/reducers';
import {
  communityDetails,
  communityCategoriesReducer,
  showOnlyCommunityDetailsReducer,
  setCommunityDetails,
  postComment,
  setPostCommentView,
  postCommentModal,
  getPostDetails,
  postLikes,
  postCreateModalReducer,
  communityNewMessage,
  communityOldMessage,
  selectedCommunityDetails,
  unreadCommunityMessageCountReducer
} from '../components/community-forum/reducers';
import {
  socialFeed,
  feedCommentModal,
  feedComment,
  socialImageSlider,
  postAddModal,
  feedLike
} from '../components/social/reducers';
import {
  gamificationChallenges,
  gamificationLeaderboard,
  gamificationShowPopup,
  showAward,
  creditedGamePointsReducer,
  gamificationTeamLeaderBoard
} from '../components/gamification/reducers';
import { galleryImages, imageDetails } from '../components/gallery/reducers';
import {
  surveyRecord,
  selectedSurvey,
  showBackSurvey
} from '../components/survey/reducers';
import {
  scheduleDatesReducer,
  myAgenda,
  selectedDateAgenda
} from '../components/agenda/reducers';
import {
  userMeetings,
  sessionMeetings,
  meetingModalReducer,
  meetingSettingOpenReducer,
  meetingSettingReducer,
  meetingScheduleDatesReducer
} from '../components/meetings/reducers';
import {
  appUserNotes,
  appuserNotes,
  noteDetailsReducer,
  showBackNotesScreenReducer
} from '../components/notes/reducers';
import { eventMaps, eventMapDetails } from '../components/maps/reducer';
import {
  eventFAQs,
  selectedFAQ,
  showBackFAQ
} from '../components/event-guide/reducers';
import {
  notificationReducer,
  selectedNotificationReducer,
  notifiedSocialPostDetailsReducer,
  notificationUnreadCountReducer,
  notifiedCommunityDetailsReducer,
  notifiedChatDetailsReducer,
  outreachModalReducer
} from '../components/notifications/reducers';
import {
  globalSearchReducer,
  latestGlobalSearchReducer,
  selectedGlobalSearchReducer
} from '../components/global-search/reducer';
import {
  myScanReducer,
  selectedScanItemReducer,
  selectedScanLinkedItemReducer,
  scannedIDsReducer,
  leadUserReducer,
  exhibitorLeadForm
} from '../components/myscans/reducers';
import {
  appuserActivitiesReducer,
  getActivityFormReducer
} from '../components/activity/reducers';
import { myItineraryListReducer } from '../components/itinerary/reducers';

const loginReducer = (state = true, action) => {
  // need to change it to false
  state = loadState();

  if (state == undefined) {
    state = {
      isLoggedIn: false
    };
  }

  if (action.type === ACTION_LOGIN) {
    state.isLoggedIn = action.payload;
  }

  if (action.type === ACTION_LOGOUT) {
    state.isLoggedIn = action.payload;
  }

  return state.isLoggedIn;
};

/**
 * Boolean flag set to true when 403 error appears (Forbidden access)
 */
const unAuthorizedApiCalled = (state = false, action) => {
  if (action.type == UNAUTHORIZED_API_CALLED) return action.payload;
  return state;
};

const tokensReducer = (state = {}, action) => {
  state = loadState();

  if (
    state == undefined ||
    state?.session == undefined ||
    _.isEmpty(state?.session?.apiKey) ||
    _.isEmpty(state?.session?.instance_url)
  ) {
    state = {
      session: {
        isapi4: IS_API4,
        instance_url: INSTANCE_URL,
        apiKey: APP_API_KEY,
        sessionToken: '',
        eventid: null,
        eventname: '',
        eventtimezone: '',
        seocode: '',
        group_number: null,
        udfid: null,
        userid: null,
        emailid: '',
        firstname: '',
        lastname: '',
        isadmin: false,
        site_url: SITE_URL,
        language: INITIAL_APP_LANGUAGE,
        theme: INITIAL_APP_THEME,
        userChoseTheme: false
      }
    };
  } else {
    switch (action.type) {
      case INITIALIZE_APP:
        state.session.isapi4 = IS_API4;
        state.session.instance_url = INSTANCE_URL;
        state.session.apiKey = APP_API_KEY;
        state.session.site_url = SITE_URL;
        state.session.language = INITIAL_APP_LANGUAGE;
        break;

      case SESSION_TOKEN:
        if (action.payload.session_token) {
          state.session.sessionToken = action.payload.session_token;
          state.session.udfid = action.payload.id ? action.payload.id : null;
        }
        break;

      case USER_INFO:
        state.session.userid = action.payload.appuserid
          ? action.payload.appuserid
          : null;
        state.session.emailid = action.payload.email ?? '';
        state.session.firstname = action.payload.firstname ?? '';
        state.session.lastname = action.payload.lastname ?? '';
        state.session.isadmin = action.payload.isadmin ?? false;
        break;

      case EVENT_DETAILS_SESSION:
        state.session.eventid = Number(action?.payload?.eventid) ?? 0;
        state.session.eventname = action.payload.eventname ?? '';
        state.session.eventtimezone = action.payload.eventtimezone ?? '';
        state.session.seocode = action.payload.seocode ?? '';
        state.session.group_number = Number(action.payload?.group_number ?? 0);
        break;

      case ACTION_LOGOUT:
        state.session.sessionToken = '';
        state.session.udfid = null;
        state.session.emailid = '';
        state.session.firstname = '';
        state.session.lastname = '';
        state.session.userid = null;
        state.session.isadmin = false;
        break;

      case CHANGE_APP_LANGUAGE:
        state.session.language = action.payload;
        break;

      case CHANGE_APP_THEME:
        state.session.theme = action.payload.applied;
        state.session.userChoseTheme = true;
        break;

      case RESET:
        reset();
        break;

      default:
        break;
    }
  }

  return state.session;
};
const userDetails = (state = {}, action) => {
  if (action.type === USER_DETAILS) {
    return action.payload;
  }
  return state;
};
const userDetailsAddOn = (state = {}, action) => {
  if (action.type === USER_DETAILS_ADDON) {
    return action.payload;
  }
  return state;
};
const userAccess = (state = {}, action) => {
  if (action.type === USER_ACCESS) {
    return action.payload;
  }
  return state;
};
const deviceSize = (state = {}, action) => {
  if (action.type === DEVICE_SIZE) {
    return action.payload;
  }
  return state;
};
const showSidebar = (state = false, action) => {
  if (action.type === SHOW_SIDEBAR) {
    return action.payload;
  }
  return state;
};

const onFirstVisitReducer = (
  state = { eventCountDown: true, suggestedCommunities: true },
  action
) => {
  if (action.type === ON_FIRST_VISIT) return action.payload;
  return state;
};

const commonFilterLIST = (state = { totalCount: 0 }, action) => {
  if (action.type === COMMON_FILTER_SELECTED_LIST) {
    return action.payload;
  }
  return state;
};

const loginModalReducer = (state = {}, action) => {
  if (action.type === LOGIN_MODAL) {
    return action.payload;
  }
  return state;
};

const eventDetails = (state = {}, action) => {
  if (action.type === EVENT_DETAILS) {
    return action.payload;
  }
  return state;
};

const eventSettings = (state = {}, action) => {
  if (action.type === EVENT_SETTINGS) {
    return action.payload;
  }
  return state;
};

const speakerCategories = (state = {}, action) => {
  if (action.type === SPEAKER_CATEGORY) {
    return action.payload;
  }
  return state;
};
const eventLanguages = (state = [], action) => {
  if (action.type === EVENT_LANGUAGES) return action.payload;
  return state;
};
const eventLocationMaps = (state = [], action) => {
  if (action.type === EVENT_LOCATION_MAPS) return action.payload;
  return state;
};
const eventForms = (state = {}, action) => {
  if (action.type === EVENT_FORMS_DETAILS) {
    return action.payload;
  }
  return state;
};
const eventTabs = (state = {}, action) => {
  if (action.type === EVENT_TAB_LIST) {
    return action.payload;
  }
  return state;
};
const eventTickets = (state = {}, action) => {
  if (action.type === EVENT_ALL_TICKETS) {
    return action.payload;
  }
  return state;
};
const redirectingCallReducer = (state = '', action) => {
  if (action.type == REDIRECTING_CALLED_FROM) {
    return action.payload;
  }
  return state;
};
const activeTab = (state = null, action) => {
  if (action.type === UPDATE_ACTIVE_TAB) {
    return action.payload;
  }
  return state;
};
const userQrDetails = (state = {}, action) => {
  if (action.type === USER_DETAILS_QR) {
    return action.payload;
  }
  return state;
};
const appuserCategories = (state = {}, action) => {
  if (action.type === APPUSER_CATEGORIES_LIST) {
    return action.payload;
  }
  return state;
};
const interestList = (state = {}, action) => {
  if (action.type === INTEREST_LIST) {
    return action.payload;
  }
  return state;
};
const webviewDetails = (state = {}, action) => {
  if (action.type == EVENT_WEBVIEW_DETAILS) {
    return action.payload;
  }
  return state;
};
const advtDetails = (state = [], action) => {
  if (action.type == EVENT_ADVT_DETAILS) {
    return action.payload;
  }
  return state;
};
const fullPageLoaderReducer = (state = false, action) => {
  // return true;
  if (action.type == APPLY_COMMON_LOADER) {
    return action.payload;
  }
  return state;
};
const lineLoaderReducer = (state = false, action) => {
  if (action.type === ACTIVATE_NAVBAR_LINE_LOADER) return action.payload;
  return state;
};
const networkingReducer = (state = false, action) => {
  if (action.type === INVOKE_NETWORK_MODAL) {
    return action.payload;
  }
  return state;
};
const timezoneDetails = (state = {}, action) => {
  if (action.type == TIMEZONE_DETAILS) {
    return action.payload;
  }
  return state;
};
const ticketsForEvent = (state = {}, action) => {
  if (action.type == TICKETS_FOR_EVENT) {
    return action.payload;
  }
  return state;
};
const meetingPopupReducer = (state = {}, action) => {
  if (action.type == MEETING_POPUP_DETAILS) {
    return action.payload;
  }
  return state;
};
const unreadChatCountReducer = (state = {}, action) => {
  if (action.type == FETCH_UNREAD_CHAT) return action.payload;
  return state;
};
const siteControlReducer = (state = 'allow', action) => {
  if (action.type === SITE_CONTROL) return action.payload;
  return state;
};
const profileToggleReducer = (
  state = { show: false, type: '', data: null, active_tab: null },
  action
) => {
  if (action.type === PROFILE_TOGGLE) return action.payload;
  return state;
};
const getLastModifiedFormField = (state = '', action) => {
  if (action.type === LAST_MODIFIED_REDUXFORM_FIELD) return action.payload;
  return state;
};
const userAccessByRole = (state = {}, action) => {
  if (action.type === USER_ACCESS_BY_ROLE) return action.payload;
  return state;
};
const commonAccessDeniedRender = (state = false, action) => {
  if (action.type === COMMON_ACCESS_DENIED_RENDER) return action.payload;
  return state;
};
const tokenExpiryModalStatus = (state = false, action) => {
  if (action.type === TOKEN_EXPIRY_MODAL_STATUS) return action.payload;
  return state;
};
const reportedContentsReducer = (
  state = {
    data: _.cloneDeep(ALLOWED_REPORTED_CONTENT_STRUCTURE),
    count: 0,
    list: []
  },
  action
) => {
  if (action.type === APPUSER_REPORTED_CONTENT) return action.payload;
  return state;
};
const appFeaturesListReducer = (state = [], action) => {
  if (action.type === APP_FEATURE_LIST) return action.payload;
  return state;
};
const regLoginOpenReducer = (state = null, action) => {
  if (action.type === APP_REG_LOGIN_OPEN) return action.payload;
  return state;
};
const restrictAtEditProfile = (state = false, action) => {
  if (action.type === RESTRICT_USER_IN_EDIT) return action.payload;
  return state;
};
const userChosenTheme = (state = ALLOWED_APP_THEMES.light, action) => {
  if (action.type === CHANGE_APP_THEME) return action.payload.chosen;
  return state;
};

const stopApiCalls = (state = STOP_API_CALLS, action) => {
  if (action.type === STOP_API_CALL_ACTION) return action.payload;
  return state;
};
const internetLost = (state = false, action) => {
  if (action.type === INTERNET_CONNECTION_LOST) return action.payload;
  return state;
};

const rootReducer = combineReducers({
  form: formReducer,
  isLoggedIn: loginReducer,
  session: tokensReducer,
  deviceSize,
  showSidebar,
  onFirstVisitReducer,
  commonFilterLIST,
  loginModalReducer,
  stopApiCalls,
  internetLost,
  unAuthorizedApiCalled,
  appFeaturesListReducer,

  // --- Common
  eventDetails,
  eventSettings,
  eventLanguages,
  eventLocationMaps,
  eventForms,
  userDetails,
  userDetailsAddOn,
  userAccess,
  eventTabs,
  eventTickets,
  activeTab,
  isVSPopup,
  vsPopupContent,
  vsPopupHeight,
  appuserCategories,
  interestList,
  vsPopupDetails,
  redirectCalledFrom: redirectingCallReducer,
  fullPageLoaderReducer,
  lineLoaderReducer,
  networkingReducer,
  timezoneDetails,
  hsPopupReducer,
  ticketsForEvent,
  meetingPopupReducer,
  unreadChatCountReducer,
  siteControlReducer,
  profileToggleReducer,
  getLastModifiedFormField,
  userAccessByRole,
  commonAccessDeniedRender,
  tokenExpiryModalStatus,
  reportedContentsReducer,
  regLoginOpenReducer,
  restrictAtEditProfile,
  userChosenTheme,

  // --- My Profile
  speakerAttachments,
  speakerAttachmentsChanged,
  workingDynamicForm,
  productCategories,
  productSubCategories,
  masterIndustriesReducer,

  // --- Eventify
  // Event overview
  allSpeakers,
  allSponsors,
  allExhibitors,
  allSessions,
  userQrDetails,
  seenEventAds,

  // tickets
  appuserAccess,
  ownOrders,
  appuserAccessedTickets,

  // Sessions
  SchedulesDataReducers,
  SelectedScheduleDateReducer,
  scheduleTracksDataReducer,
  SelectedScheduleTrackReducer,
  trackSessionsDataReducer,
  sessionDetailsReducer,
  showSidebarReducer,
  showBackScreenReducer,
  openQAModalReducer,
  sessionQADataReducer,
  sessionPolls,
  sessionPollsListModal,
  sessionPollsActionModal,
  sessionPollsResult,
  myBookedSchedule,
  myRatedSessionReducer,
  holdThisSession: holdThisSessionDetailsReducer,
  liveQAReplyReducer,
  sessionVideoModalDetails,
  sessionRatingFormDataReducer,
  notSubmittedPollCountReducer,
  sessionsFilteredByTagsReducer,
  sessionColorsReducer,
  allEventTrackReducer,
  sessionFilterData,
  overlappingSessionsForAllTracks,

  // Speakers
  bookedSpeakers,
  speakersReducer,
  speakerDetailsReducer,
  showBackScreenSpeaker,
  speakerCategories,

  // Bookmarks
  bookmarksByTypeReducer,
  bookmarksDataReducer,

  // Gallery
  galleryImages,
  imageDetails,

  // Survey
  surveyRecord,
  selectedSurvey,
  showBackSurvey,

  // My Agenda
  scheduleDatesReducer,
  myAgenda,
  selectedDateAgenda,

  //meetings
  userMeetings,
  sessionMeetings,
  meetingModalReducer,
  meetingSettingOpenReducer,
  meetingSettingReducer,
  meetingScheduleDatesReducer,

  // Chat
  userData,
  openChatReducer,
  chatThreadData,
  chatData,
  viewUserReducer,
  attendeeListModalReducer,
  timeoutListReducer,
  showBackScreenChat,
  openFilterListReducer,
  suggestedUserDataReducer,
  openSuggestedFilterListReducer,

  // Attendee
  attendeeList,
  attendeeProfileDetailsReducer,
  showBackScreenForAttendee: showBackScreen,
  myBookmarkedUsers,
  matchAttendeeCategoryReducer,
  mainAttendeeList,

  // News
  newsData,
  newsDetails,
  bookedNews,

  // Exhibitors
  myBookedExhibitor,
  allExhibitors_exb,
  exhibitor,
  exhibitorDetails,
  appUserNotes,
  showOnlyExhibitorDetailsReducer,
  exbCountryReducer,
  exbSectorsReducer,
  categoryList,
  exbCategoriesReducer,
  exhibitorsFilteredReducer,
  exhibitorsTAGFilteredReducer,

  // Sponsors
  myBookedSponsor,
  allSponsors_spn,
  sponsor,
  sponsorDetails,
  showOnlySponsorDetailsReducer,

  // Community Forum
  communityDetails,
  communityCategoriesReducer,
  showOnlyCommunityDetailsReducer,
  setCommunityDetails,
  postComment,
  setPostCommentView,
  postCommentModal,
  getPostDetails,
  postLikes,
  postCreateModalReducer,
  communityNewMessage,
  communityOldMessage,
  selectedCommunityDetails,
  unreadCommunityMessageCountReducer,

  //Social Feed
  socialFeed,
  feedComment,
  feedCommentModal,
  socialImageSlider,
  postAddModal,
  feedLike,

  // Gamification
  gamificationChallenges,
  gamificationLeaderboard,
  gamificationShowPopup,
  showAward,
  creditedGamePointsReducer,
  gamificationTeamLeaderBoard,

  // Notes
  appuserNotes,
  noteDetailsReducer,
  showBackNotesScreenReducer,

  // webview
  webviewDetails,

  // advertisements
  advtDetails,

  // maps
  eventMaps,
  eventMapDetails,

  // event guide
  eventFAQs,
  selectedFAQ,
  showBackFAQ,

  // notifications
  notificationReducer,
  selectedNotificationReducer,
  notifiedSocialPostDetailsReducer,
  notificationUnreadCountReducer,
  notifiedCommunityDetailsReducer,
  notifiedChatDetailsReducer,
  outreachModalReducer,

  // global search
  globalSearchReducer,
  latestGlobalSearchReducer,
  selectedGlobalSearchReducer,

  // my scans
  myScanReducer,
  selectedScanItemReducer,
  selectedScanLinkedItemReducer,
  scannedIDsReducer,
  leadUserReducer,
  exhibitorLeadForm,

  // my activity
  appuserActivitiesReducer,
  getActivityFormReducer,

  // my itinerary
  myItineraryListReducer
});

// put reducers in comma separated '' inside this array to store them in localstorage
const persistThisReducers = [];

export default rootReducer;
export { persistThisReducers };
